import { add, isAfter, startOfDay } from '@sequencehq/utils/dates'
import { CubeStatus } from 'Cube/domain/cube.domain.types'

const SCHEDULE_STATUSES_WITH_COMPLETED_PHASES = [
  CubeStatus.ScheduleActive,
  CubeStatus.ScheduleCompleted,
  CubeStatus.ScheduleCancelled
]

export const isPhaseCompleted = (args: {
  scheduleStatus: CubeStatus
  persistedPhaseEndDate: Date | undefined
  today: Date
  isBeforeAmendmentEffectiveFrom?: boolean
}): boolean => {
  const canHaveCompletedPhases =
    Boolean(args.isBeforeAmendmentEffectiveFrom) ||
    SCHEDULE_STATUSES_WITH_COMPLETED_PHASES.includes(args.scheduleStatus)

  if (!canHaveCompletedPhases || !args.persistedPhaseEndDate) {
    return false
  }

  return isAfter(
    args.today,
    startOfDay(add(args.persistedPhaseEndDate, { days: 1 }))
  )
}
